import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { NavigationService } from '../../shared/services/navigation.service';
import {AuthService} from "@auth0/auth0-angular";

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  constructor(private authService: AuthenticationService, private navigation: NavigationService, private auth0SService: AuthService) {
  }

  ngOnInit() {
    this.authService.disconnect();
    this.auth0SService.logout({
      returnTo: window.location.origin
    })
  }
}
